import { SourceRunStatus } from '@/lib/sources/source-types';

export function getFailedSources(statuses: SourceRunStatus[]): SourceRunStatus[] {
  return statuses.filter((s) => s.status === 'error');
}

export function formatFailedSummary(failed: SourceRunStatus[]): string {
  if (failed.length === 0) return '';
  if (failed.length === 1) {
    return `1 source failed: ${failed[0].domain}. Results may be incomplete.`;
  }
  return `${failed.length} sources failed: ${failed.map((s) => s.domain).join(', ')}. Results may be incomplete.`;
}
